import { TextInput } from '@mantine/core';
import { IFormInputSpecDeviceEvidenceField } from 'pages/revisions-module/template-editor/editors/form/types';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';
import { useEffect, useMemo } from 'react';
import { getEvidenceFieldValue } from 'utils/evidence-field';

/**
 * Device evidence field input for the revision form.
 */
export default function RevisionFieldDeviceEvidenceField({
  spec,
  name,
  deviceId,
}: RevisionFieldProps<IFormInputSpecDeviceEvidenceField>) {
  const { form, revision } = useFillOutRevisionDataProvider();

  const device = useMemo(
    () => revision.devices.find((device) => device.deviceId === deviceId),
    [revision.devices, deviceId]
  );

  const evidenceField = useMemo(
    () => device?.evidenceFields.find((field) => field.evidenceFieldId === Number(spec.evidenceFieldId)),
    [device, spec.evidenceFieldId]
  );

  useEffect(() => {
    const rawValue = evidenceField ? getEvidenceFieldValue(evidenceField) ?? '' : '';

    const newValue =
      evidenceField?.fieldType === 'number'
        ? Number(rawValue)
            .toFixed(evidenceField?.precision || 0)
            .replace('.', ',')
        : evidenceField?.fieldType === 'checkbox'
        ? rawValue
          ? 'Áno'
          : 'Nie'
        : rawValue;

    const currentValue = form.getInputProps(name).value;

    if (currentValue !== newValue) {
      form.setFieldValue(name, newValue);
    }
  }, [evidenceField, form, name]);

  return (
    <TextInput
      size="lg"
      name={name}
      label={spec.label}
      required={spec.required}
      readOnly={spec.readOnly}
      {...form.getInputProps(name)}
    />
  );
}
